<template>
	<v-dialog
		v-model="showDialog"
		max-width="600px"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
	>
		<v-card :tile="$vuetify.breakpoint.xs">
			<v-toolbar dark color="primary" dense flat>
				<v-toolbar-title style="color: white">添付ファイル削除 </v-toolbar-title>
				<v-spacer></v-spacer>
				<v-btn icon dark @click="showDialog = false" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>
			<v-sheet class="pa-2" elevation="0">
				<v-form v-model="valid" ref="form">
					<p >ファイル：XXXX.pdf</p>
					<!-- <p >ファイル：{{ file.name }}</p> -->
					<v-textarea
						class="mt-4"
						v-model="reason"
						label="削除理由"
						:rules="[rules.required]"
						dense
						outlined
					/>
				</v-form>
			<v-row class="mt-4" no-gutters justify="center">
				<v-btn color="red" :dark="valid" :disabled="!valid" @click="deleteFile">
					<v-icon class="mr-1">mdi-delete</v-icon>
					削除
				</v-btn>
			</v-row>
			</v-sheet>
		</v-card>
	</v-dialog>
</template>

<script>
import axios from "axios"
import errorHandling from "../../../helper/errorHandling"
import authenticate from "../../../helper/authenticate"
import common from "../../../helper/common"
import rules from "../../../helper/rules"

export default {
	props: {
		dialog: {
			type: Boolean,
			required: false,
			default: false,
		},
		file: {
			type: null,
			required: false,
			default: () => {
				return {
					id: null,
					name: null,
					created_at: null,
					user: {
						full_name: null,
					},
				}
			},
		},
	},
	data() {
		return {
			menu: false,
			valid: false,
			reason: null,
			common,
			rules,
		}
	},
	methods: {
		deleteFile() {
			// TODO:要確認
			const headers = authenticate.setHeader()
			const url = `/erp/v1/attached_files/${this.file.id}`
			axios
				.delete(url, { headers })
				.then((res) => {
					this.$emit("delete-file", res.data)
					this.$store.dispatch("setFlash", {
						type: "notice",
						text: "ファイル名",
					})
					this.$refs.deleteDialog.closeDialog()
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
	},
	computed: {
		showDialog: {
			get() {
				return this.dialog
			},
			set(newVal) {
				return this.$emit("update:dialog", newVal)
			},
		},
	},
	watch: {
		file(newVal) {
			let file = newVal.name.split(".")
			this.extension = file[file.length - 1]
			file = file.slice(0, file.length - 1)
			this.fileName = file.join(".")
		},
		deep: true,
	},
}
</script>